import { render } from "./PrintQueueItemDialog.vue?vue&type=template&id=3d163760"
import script from "./PrintQueueItemDialog.vue?vue&type=script&lang=js"
export * from "./PrintQueueItemDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__